import { useMemo } from "react";

export function useFitHorizontal(
	pageWidth: number,
	pageHeight: number,
	wrapperWidth: number,
	wrapperHeight: number
): boolean {
	return useMemo(() => {
		const wRatio = pageWidth / wrapperWidth;
		const hRatio = pageHeight / wrapperHeight;
		if (wRatio < hRatio) {
			return false;
		}
		return true;
	}, [pageHeight, pageWidth, wrapperWidth, wrapperHeight]);
}
